<!-- App.vue -->
<template>
  <div id="app">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <router-view></router-view>
    </div>
    
    <!-- 全局底部导航 -->
    <AllTab v-if="showTab" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AllTab from './components/AllTab.vue'

const route = useRoute()

// 在某些页面隐藏 Tab 栏，比如登录页
const showTab = computed(() => {
  const hidePages = ['/login', '/register']
  return !hidePages.includes(route.path)
})
</script>

<style>
#app {
  position: relative;
  min-height: 100vh;
}

.main-content {
  padding-bottom: 60px; /* 为底部导航留出空间 */
}
</style>